import { useRef, useEffect } from 'react';
import { useFields } from './Fields.Context';
import type { FieldsProviderProps } from './Fields.Context';
import { FieldsEditor } from './Fields.Editor';
import { useRecoilValue } from 'recoil';
import { reportStatusState } from '../state';
import { isAddendumEditorEditable } from './utils';

export const FieldsAddendumEditor = ({
  isDisabled,
  isClaimedByMe,
  onInit,
  onDestroy,
  onError,
}: Readonly<{
  isDisabled: boolean;
  isClaimedByMe: boolean;
  onInit?: FieldsProviderProps['onInit'];
  onDestroy?: FieldsProviderProps['onDestroy'];
  onError?: FieldsProviderProps['onError'];
}>): React.ReactElement | null => {
  const [{ addendum }, { onAddendumChange }] = useFields();
  const status = useRecoilValue(reportStatusState);
  const ref = useRef<HTMLDivElement>(null);
  const hasAddendum = addendum != null;
  const isEditorEditable = isAddendumEditorEditable({
    hasAddendum,
    isClaimedByMe,
    isDisabled,
    status,
  });

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [hasAddendum]);

  if (addendum == null || !isClaimedByMe) return null;

  return (
    <div ref={ref}>
      <FieldsEditor
        initialContent={addendum.content}
        onChange={onAddendumChange}
        isDisabled={!isEditorEditable}
        onInit={onInit}
        onDestroy={onDestroy}
        onError={onError}
        variant="report"
        isAddendumEditor={true}
        label="New Addendum"
      />
    </div>
  );
};
